import React from 'react';
import AddUsuarioButton from './Usuarios/AddUsuarioButton';
import { useAjustes } from '../../Context/AjustesContext';
import { gestorPodeCadastrarEditar } from '../../utils/gestorPermissoes';

const ActionButtons = ({
	nivel,
	usuariosManager
}) => {
	const { ajustes } = useAjustes();
	const podeAdicionarUsuario =
		nivel === 'Administrador' ||
		nivel === 'RH' ||
		(nivel === 'Gestor' && gestorPodeCadastrarEditar(ajustes));

	return (
		<div className="container-fluid mt-3 mt-md-0">
			<div className="row mb-4">
				{podeAdicionarUsuario && (
					<AddUsuarioButton openAddUsuarioModal={usuariosManager.openAddUsuarioModal} />
				)}
			</div>
		</div>
	);
};

export default ActionButtons; 